import { MouseEvent, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { View } from '@shared/components/View';
import styles from './AnchoredView.module.css';
import { AnchoredSheetProps } from './props';

type AnchoredViewProps = Omit<AnchoredSheetProps, 'title' | 'renderTitleBar' | 'align'>;

export function AnchoredView({
  children,
  anchorName,
  className,
  backdropClassName,
  style,
  onClose,
}: AnchoredViewProps) {
  const onClickOverlay = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      event.stopPropagation();
      onClose();
    },
    [onClose],
  );

  const onClickContent = useCallback((event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  }, []);

  return ReactDOM.createPortal(
    <>
      <View
        aria-hidden="true"
        onClick={onClickOverlay}
        className={[styles.anchoredViewBackdrop, backdropClassName]}
        testID="bottom-sheet-overlay"
      />
      <View
        onClick={onClickContent}
        className={[styles.anchoredView, className]}
        style={{ positionAnchor: anchorName, ...style }}
      >
        {children}
      </View>
    </>,
    document.body,
  );
}
